export const teamUpdates = {
  title: 'Team updates',
  subtitle: 'Typed group feeds for lasting updates and thread chat',
  chats: 'Chats',
  newChat: 'New chat',
  empty: 'No chats yet — start one with the new chat button.',
  emptyMember: 'You are not in any chats yet.',
  createGroup: 'Create chat',
  editGroup: 'Edit chat',
  deleteGroup: 'Delete chat',
  deleteGroupAria: 'Delete chat {{name}}',
  deleteGroupTitle: 'Delete this chat?',
  deleteGroupConfirm:
    'This permanently removes “{{name}}”, every post and reply, polls, reactions, call records, and attached media. This cannot be undone.',
  deleteGroupTypeName: 'Type “{{name}}” to confirm',
  groupName: 'Chat name',
  groupNameRequired: 'Enter a chat name',
  description: 'Description',
  organisation: 'Organisation',
  organisationLocked: 'Team updates are available for the OVERHEAR organisation only',
  members: 'Members',
  membersHelper: 'Facilitators and related org roles, plus platform admins',
  membersRequired: 'Select at least one member',
  membersDialog: {
    title: 'Group members',
    subtitle: '{{name}} · {{count}} members',
    empty: 'No members to show.',
    you: '{{name}} (you)',
    leave: 'Leave group',
    leaveTitle: 'Leave this group?',
    leaveConfirm:
      'You will stop receiving updates from “{{name}}”. A super admin can add you again later.',
    open: 'View members',
    openAria: 'View members of {{name}}',
    addLabel: 'Add member',
    noEligible: 'No eligible people left to add',
    removeAria: 'Remove {{name}} from group',
    removeTitle: 'Remove member?',
    removeConfirm: 'Remove {{name}} from “{{group}}”? They will lose access to this chat.',
  },
  unreadBadgeAria: '{{count}} unread team updates',
  openFeed: 'Open chat',
  memberCount: '{{count}} members',
  backToGroups: 'All chats',
  selectChat: 'Select a chat from the list',
  composePlaceholder: 'Write a new {{type}}…',
  chooseTypeThenWrite: 'Choose a type, then write…',
  selectMessageType: 'Select a message type before posting.',
  composeLabel: 'New post',
  composeTitleLabel: 'Title',
  composeTitlePlaceholder: 'Add a short title…',
  composeAddTitle: 'Add a title',
  composeAddTitleHint: 'Longer posts are easier to skim with a title',
  post: 'Post',
  replyComposeLabel: 'Reply',
  replyPlaceholder: 'Reply in thread…',
  reply: 'Reply',
  threadLabel: 'Thread · {{count}}',
  closeThread: 'Close thread',
  showThreads: 'Show thread replies',
  hideThreadsHint: 'Turn off for a parents-only skim',
  filters: 'Types',
  filtersPanelShow: 'Show filters',
  filtersPanelHide: 'Hide filters',
  noPosts: 'No posts yet — share the first update.',
  noPostsFiltered: 'No posts match these type filters.',
  accessDenied: 'You do not have access to this group.',
  types: {
    update: 'Update',
    fyi: 'FYI',
    clarify: 'Clarification',
    logistics: 'Logistics',
    question: 'Question',
    poll: 'Poll',
    decision: 'Decision',
    social: 'Chat',
    request: 'Request',
  },
  request: {
    label: 'Request',
    composeHint:
      'Choose one or more people — each can accept it into their own to-do list',
    assigneeLabel: 'Ask',
    assigneePlaceholder: 'Select people…',
    assigneeRequired: 'Choose at least one person',
    for: 'For {{name}}',
    someone: 'someone',
    you: 'you',
    accept: 'Accept',
    decline: 'Decline',
    addedToTodo: 'Added to your to-do list',
    workStreamTask: 'Work stream task',
    openWorkStream: 'Open {{name}}',
    status: {
      pending: 'Waiting',
      accepted: 'Accepted',
      declined: 'Declined',
    },
  },
  poll: {
    label: 'Poll',
    composeHint: 'Question posts include a poll — edit the options below',
    editHint: 'Edit the poll options — existing votes stay on unchanged options',
    optionPlaceholder: 'Option {{n}}',
    addOption: 'Add option',
    removeOption: 'Remove option',
    minOptions: 'Add at least two poll options',
    tapToVote: 'Tap to vote',
    voted: 'Your vote',
    waiting: 'Waiting on the group · you can vote too',
    voteCount: '{{count}} votes',
  },
  reactions: {
    add: 'Add reaction',
    you: 'You',
  },
  atAGlance: {
    title: 'At a glance',
    edit: 'Edit at a glance',
    add: 'Add what’s true now…',
    placeholder: 'e.g. Pilot session likely September · planning call rescheduled · facilitator needed for 1 Aug',
    helper: 'Short durable status — dates, reschedules, outstanding asks. Not the full chat history.',
    save: 'Save',
    label: 'At a glance',
    fieldHelper: 'Pinned summary shown at the top of this chat',
  },
  fabs: {
    label: 'Attention shortcuts',
    missedTitle: 'Jump to missed replies',
    missedAria: '{{count}} missed replies',
    missedNone: 'No missed replies',
    questionsTitle: 'Unanswered questions and polls',
    questionsHint: 'Vote here — structured answers stay on the parent; chat still lives in the thread.',
    questionsAria: '{{count}} unanswered polls',
    questionsNone: 'No unanswered polls',
    questionsEmpty: 'No unanswered questions or polls right now.',
    newBelowTitle: 'Jump to new posts',
    newBelowAria: '{{count}} new posts below',
    newBelowNone: 'No new posts below',
    jumpToPost: 'Show in feed',
  },
  success: {
    groupCreated: 'Group created',
    groupUpdated: 'Group updated',
    atAGlanceSaved: 'At a glance updated',
    posted: 'Posted',
    replied: 'Reply sent',
    requestAccepted: 'Request accepted — added to your to-do list',
    requestDeclined: 'Request declined',
    requestSent: 'Request sent',
    goToTeamUpdates: 'Go to Team Updates',
    updated: 'Updated',
    deleted: 'Deleted',
    leftGroup: 'You left the group',
    memberAdded: 'Member added',
    memberRemoved: 'Member removed',
    groupDeleted: 'Chat deleted',
  },
  actions: {
    menu: 'Message actions',
    edit: 'Edit',
    delete: 'Delete',
    info: 'Info',
    save: 'Save',
    cancel: 'Cancel',
    edited: 'edited',
    deletePostTitle: 'Delete post?',
    deletePostConfirm: 'This removes the post, its replies, and any attached media.',
    deleteReplyTitle: 'Delete reply?',
    deleteReplyConfirm: 'This reply and any attached media will be removed.',
  },
  ticks: {
    sent: 'Sent',
    received: 'Received by everyone',
    seen: 'Seen by everyone',
  },
  receipts: {
    title: 'Message info',
    empty: 'No other members in this chat yet.',
    seen: 'Seen',
    received: 'Received',
    pending: 'Not received yet',
  },
  mentions: {
    empty: 'No members match',
    ariaSuggestions: 'Member suggestions',
    hint: 'Type @ to mention someone',
  },
  fileLinks: {
    empty: 'No files match',
    ariaSuggestions: 'Organisation file suggestions',
    hint: 'Type / to link an organisation file',
  },
  media: {
    addPhoto: 'Add photo',
    removeImage: 'Remove image',
  },
  voice: {
    record: 'Record voice note',
    stop: 'Stop recording',
    play: 'Play voice note',
    pause: 'Pause voice note',
    remove: 'Remove voice note',
    recording: 'Recording voice note',
    ready: 'Voice note ready to send',
    transcript: 'Transcript',
    expandTranscript: 'Show full transcript',
    collapseTranscript: 'Hide transcript',
    transcribing: 'Transcribing…',
    transcriptFailed: 'Transcription failed',
  },
  notifications: {
    newPost: '{{author}} posted in {{group}}',
    newReply: '{{author}} replied in {{group}}',
    newCall: '{{author}} started a call in {{group}}',
    desktopTitle: '{{group}} · Team updates',
  },
  notificationSettings: {
    title: 'Notification settings',
    subtitle:
      'Choose when Team updates can interrupt you. Settings are saved in this browser.',
    open: 'Notification settings',
    enabled: 'Notify me about new posts and replies',
    desktopEnabled: 'Also use browser/desktop alerts when this tab is in the background',
    muteOutsideWorkHours: 'Mute outside work hours',
    workHoursStart: 'Work hours start',
    workHoursEnd: 'Work hours end',
    workDaysOnly: 'Weekdays only',
    muteReplies: 'Mute reply notifications',
    muteWhenViewingChat: 'Mute in-app alerts while viewing that chat',
    mutedChats: 'Muted chats',
    mutedChatsNone: 'No muted chats',
    reset: 'Reset to defaults',
    save: 'Save',
  },
  call: {
    startAria: 'Start video call in {{name}}',
    inCallAria: 'You are in a call in {{name}}',
    joinAria: 'Join video call in {{name}}',
    stageAria: 'Group video call',
    connecting: 'Connecting…',
    connected: 'In call · {{count}} people',
    disconnected: 'Disconnected',
    reconnect: 'Reconnect',
    you: '{{name}} (you)',
    mute: 'Mute microphone',
    unmute: 'Unmute microphone',
    cameraOff: 'Turn camera off',
    cameraOn: 'Turn camera on',
    leave: 'Leave call',
    end: 'End call',
    join: 'Join call',
    inCall: 'In call',
    activeBanner: '{{name}} started a call · {{count}} in call',
    techCheck: {
      title: 'Check camera and microphone',
      description: 'Confirm your devices work before joining the group call.',
      camera: 'Camera',
      microphone: 'Microphone',
      selectCamera: 'Camera source',
      selectMicrophone: 'Microphone source',
      checking: 'Checking…',
      working: 'Ready',
      failed: 'Not available',
      cameraPreviewOff: 'Camera off or unavailable',
      micMeter: 'Microphone level',
      micMeterHint: 'Speak to see the meter move',
      permissionError:
        'Could not access camera or microphone. Check browser permissions and try again.',
      deviceSwitchError: 'Could not switch to that device. Try another source or retry.',
      cancel: 'Cancel',
      retry: 'Retry',
      join: 'Join call',
    },
    selectCamera: 'Camera',
    selectMicrophone: 'Microphone',
  },
};
